import { EVRAK_TURLERI } from "./choices";

/** Türkçe dosya adı → aranabilir metin */
function normalizeName(filename) {
    const base = String(filename || "")
        .replace(/\.[^.]+$/i, "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[_\-.]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    return base;
}

/** Öncelik sırası: daha özel kalıplar önce */
const RULES = [
    { code: "ISLAH_DILEKCE", match: ["islah dilekce", "islah"] },
    {
        code: "GONDERI_BELGESI",
        match: ["gonderi belgesi", "gonderi", "kargo", "kurye", "ptt", "takip no"],
    },
    { code: "VEKALET", match: ["vekaletname", "vekalet", "muvafakat", "avukatlik vekalet"] },
    {
        code: "TUTANAK",
        match: [
            "kaza tespit tutanagi",
            "kaza tespit",
            "tespit tutanagi",
            "tespit tutanak",
            "ktt",
            "tutanak",
        ],
    },
    {
        code: "KAZA_RESIM",
        match: [
            "kaza resim",
            "hasar resim",
            "kaza fotograf",
            "kaza gorsel",
            "kaza resimleri",
            "hasar fotograf",
            "hasar gorsel",
        ],
    },
    { code: "EKSPER", match: ["ekspertiz raporu", "ekspertiz", "eksper raporu", "eksper"] },
    { code: "DILEKCE", match: ["dilekce", "basvuru dilekce", "muracaat dilekce"] },
    { code: "KUSUR", match: ["kusur durumu", "kusur belgesi", "kusur"] },
    { code: "RUHSAT", match: ["ruhsat", "tescil belgesi", "tescil", "arac ruhsat"] },
    { code: "KAZA_RESIM", match: ["resimleri", "resimler", "fotograf", "foto", "gorsel"] },
];

/** Görsel uzantıları — eşleşme yoksa kaza resmi say */
const IMAGE_EXT = /\.(jpe?g|png|webp|heic|gif|bmp|tif{1,2})$/i;

/**
 * Yüklenen dosya adından evrak türü kodu (EVRAK_TURLERI value).
 * Eşleşme yoksa görsel ise KAZA_RESIM, değilse DIGER_EVRAK.
 */
export function detectEvrakTuruFromFilename(filename) {
    const text = normalizeName(filename);
    if (!text) return "DIGER_EVRAK";

    for (const rule of RULES) {
        for (const phrase of rule.match) {
            if (text.includes(phrase)) return rule.code;
        }
    }
    if (IMAGE_EXT.test(String(filename || ""))) return "KAZA_RESIM";
    return "DIGER_EVRAK";
}

export function evrakTuruLabel(code) {
    return EVRAK_TURLERI.find((t) => t.value === code)?.label || code || "—";
}
